import { render, staticRenderFns } from "./EditLandingPageChrome.vue?vue&type=template&id=008ebda4&scoped=true&"
import script from "./EditLandingPageChrome.vue?vue&type=script&lang=js&"
export * from "./EditLandingPageChrome.vue?vue&type=script&lang=js&"
import style0 from "./EditLandingPageChrome.vue?vue&type=style&index=0&id=008ebda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008ebda4",
  null
  
)

export default component.exports